import React, { useState, useEffect } from 'react';
import { getLawyerPrices } from '../../services/api';

export default function PriceSelector({ onPriceChange, isLawyer = false }) {
  const [prices, setPrices] = useState([]);
  const [selectedPrice, setSelectedPrice] = useState('');
  const [firstConsultation, setFirstConsultation] = useState(false);
  const [firstConsultationPrice, setFirstConsultationPrice] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await getLawyerPrices();
        setPrices(response);
      } catch (error) {
        console.error('Error fetching prices:', error);
        // Fallback
        setPrices([
          { id_rango: '1', rango: '$500 - $1,000' },
          { id_rango: '2', rango: '$1,000 - $2,000' },
          { id_rango: '3', rango: '$2,000 - $3,000' },
          { id_rango: '4', rango: '$3,000+' },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();
  }, []);

  const handlePriceChange = e => {
    const priceId = e.target.value;
    setSelectedPrice(priceId);
    updatePrice(priceId, firstConsultation, firstConsultationPrice);
  };

  const handleFirstConsultationChange = e => {
    const checked = e.target.checked;
    setFirstConsultation(checked);
    if (!checked) {
      setFirstConsultationPrice('');
      updatePrice(selectedPrice, false, '');
    } else {
      updatePrice(selectedPrice, true, firstConsultationPrice);
    }
  };

  const handleFirstConsultationPriceChange = e => {
    const price = e.target.value;
    setFirstConsultationPrice(price);
    updatePrice(selectedPrice, firstConsultation, price);
  };

  const updatePrice = (priceId, hasFirstConsultation, firstPrice) => {
    if (onPriceChange) {
      onPriceChange({
        priceRange: priceId,
        hasFirstConsultation,
        firstConsultationPrice: hasFirstConsultation ? firstPrice : null,
      });
    }
  };

  if (loading) {
    return (
      <div className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-500">
        Cargando rangos de precios...
      </div>
    );
  }

  const selectClassName = `w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors appearance-none ${
    isLawyer
      ? 'bg-transparent border-gray-400 text-white focus:ring-gray-200'
      : 'bg-white border-gray-300 text-gray-900'
  }`;

  const inputClassName = `w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors ${
    isLawyer
      ? 'bg-transparent border-gray-400 text-white placeholder-gray-300 focus:ring-gray-200'
      : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'
  }`;

  return (
    <div className="space-y-4">
      {/* Rango de precios por hora */}
      <div className="flex flex-col">
        <label className={`text-xs mb-1 ${isLawyer ? 'text-gray-300' : 'text-gray-500'}`}>
          Precio por Hora *
        </label>
        <div className="relative">
          <select value={selectedPrice} onChange={handlePriceChange} className={selectClassName}>
            <option value="">Seleccione rango de precio</option>
            {prices.map(price => (
              <option key={price.id_rango} value={price.id_rango}>
                {price.rango}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Primera consulta gratuita */}
      <div className="flex flex-col space-y-2">
        <label className={`flex items-center space-x-2 cursor-pointer`}>
          <input
            type="checkbox"
            checked={firstConsultation}
            onChange={handleFirstConsultationChange}
            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <span className={`text-sm ${isLawyer ? 'text-white' : 'text-gray-900'}`}>
            Ofrecer primera consulta con precio especial
          </span>
        </label>

        {firstConsultation && (
          <input
            type="number"
            value={firstConsultationPrice}
            onChange={handleFirstConsultationPriceChange}
            placeholder="Precio de primera consulta"
            className={inputClassName}
            min="0"
          />
        )}
      </div>
    </div>
  );
}
